import React, { useEffect, useState } from "react";
import * as Styles from "./styles";
import MaterialUI from "../../../../../../../../../material-UI";

interface Props {
  onClose: () => void;
  mutate: any;
  refetch: () => void;
  reset1: () => void;
  isLoading: boolean;
  isSuccess: boolean;
}

const Footer: React.FC<Props> = (props) => {
  const handleClick = () => {
    props.mutate();
  };

  useEffect(() => {
    if (props.isSuccess) {
      props.onClose();
      props.refetch();
      props.reset1();
    }
  }, [props.isSuccess]);
  return (
    <Styles.SecondContainer>
      <Styles.Button onClick={props?.onClose}>
        <Styles.LightTextBlue>Não</Styles.LightTextBlue>
      </Styles.Button>
      <Styles.ButtonBlue
        onClick={() => {
          handleClick();
        }}
      >
        {props.isLoading ? (
          <MaterialUI.CircularProgress size={22} style={{ color: "#fff" }} />
        ) : (
          <Styles.LightText>Sim</Styles.LightText>
        )}
      </Styles.ButtonBlue>
    </Styles.SecondContainer>
  );
};

export default Footer;
